import { useTranslation } from "react-i18next";
import { Spinner } from "@/components/ui/spinner";

interface LoadingProps {
  message?: string;
}

export function Loading({ message }: LoadingProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3">
      <Spinner className="size-8 text-primary" />
      <p className="text-sm text-muted-foreground">{message ?? t("state.loading")}</p>
    </div>
  );
}
